import script from "./ClientsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientsDetail.vue?vue&type=script&setup=true&lang=js"

import "./ClientsDetail.vue?vue&type=style&index=0&id=1675f0d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1675f0d2"]])

export default __exports__